import { Card, CardContent, CardActions, Button, Typography, Box } from "@mui/material";
import { useNavigate } from 'react-router-dom';

const CardPayment = ({ currency, icon, text, href }) => {
  const navigate = useNavigate();
  return (
    <Card 
        sx={{ 
            minWidth: { xs: "150px", md: "560px" }, 
            maxWidth: { xs: "300px", md: "560px" }, 
            backgroundColor: "rgba(20, 20, 20, 1)", 
            border: "1px solid #a95052", 
            borderRadius: "12px",
            padding: "20px"}}>
      <CardContent 
        sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
        <Box component="img" src={icon} alt={currency} width={120} height={120} />
        <Typography paddingY={2} variant="h4" color="white">
          {currency}
        </Typography>
        <Typography maxWidth={310} marginTop={3} fontSize={20} fontWeight={500} color="#98989A">
          {text}
        </Typography>
      </CardContent>
      <CardActions sx={{ display: "flex", justifyContent: "center" }}>
        <Button
            variant="contained"
            width="100%"
            onClick={() => navigate(href)}
            sx={{
                px: "80px",
                paddingX: { md: "80px", xl: "80px" },
                fontSize: { xs: "14px", md: "16px", xl: "18px" },
                borderRadius: "40px",
                color: "#f0e5d2", 
                backgroundColor: "#a95052",
                "&:hover": {
                backgroundColor: "#8c3e47", 
                color: "white", 
                },
                transition: "background-color 0.3s ease, color 0.3s ease"
            }}
            >
            PAGAR
        </Button>
    </CardActions>

    </Card>
  );
};

export default CardPayment;
